module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAACEhIqDg4iDg4iDg4mDg4mDg4mDg4mEhImDg4qDg4qPj4+CgoiDg4iDg4iCgomCgoiCgoqCgouDg4qHh4yXl5f///+CgoiCgomDg4mCgoh48XkNAAAAGnRSTlMAer2i917d1WtMRRDx8Oa7rowsJRoLAbKTVKi9jA4AAACrSURBVFjD7dbJCsMwDARQK7azr83SVv//oY2DexNEYEMu804DhgH5NAYAIJfO9sxc1iZoK1bobScU2fjannlzrGOFoiG+fc7sWWkQiv7HULiMlSqhqHEclOHs480qrjGCtSYiv1/5aEihXg0APMfPRTHZ15W3ZSruzd4IiC8uNO0l65BQNMa35cxfVhpzF6Wflu2zAeAx6bMmfWjln37pYzR9Hucb7AAAmfwACgxFxfHaSOAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/header_menu.png
// module id = u6lH
// module chunks = 1